// 普通接口
import {getEncryptBody, getHeader} from '../../util/makePostData'
import {post} from '../../request/http'

export function handleSend (data, appCode, bizCode, operaType = '0', showType = 'Alert', isDesensit = 'true') {
  // 加密处理
  let encryptResult = getEncryptBody(appCode, bizCode, data, operaType, isDesensit)
  let encryptMsg = encryptResult.body
  let config = {
    headers: encryptResult.headers
  }
  let interfaceCode = encryptResult.interfaceCode

  return new Promise(resolve => {
    post('/handle', appCode, bizCode, encryptMsg, showType, config, true, interfaceCode)
      .then((res) => {
        if (res.retCode === '0000') {
          resolve({...res.BizBodyMsg, retMsg: res.retMsg})
        }
      })
  })
}

// 上传文件接口
export function handleFileSend (url = '/uploadFiles', appCode, bizCode, data, showType) {
  let result = getHeader()
  let headers = result.headers
  data.append('Content-Type', 'multipart/form-data')
  let interfaceCode = result.interfaceCode
  let token = result.token
  let timeStamp = result.timeStamp
  data.append('token', token)
  data.append('timeStamp', timeStamp)
  let config = {
    headers: headers
  }
  return new Promise(resolve => {
    post(url, appCode, bizCode, data, showType, config, true, interfaceCode)
      .then((res) => {
        if (res.retCode === '0000') {
          resolve({...res.BizBodyMsg, retMsg: res.retMsg})
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/api/erp/post.js